import * as Yup from 'yup';

const schema = Yup.object().shape({
  email: Yup.string().required('email.required').email('email.invalid')
});

export default schema;
